import { Deferred } from './Deferred';

export class Mutex {
    public waitAsync() {
        if (!this.aquired) {
            this.aquired = true;
            return Promise.resolve();
        }

        const deferred = new Deferred<void>();
        this.deferred.push(deferred);
        return deferred.promise;
    }

    public release() {
        if (!this.aquired) throw new Error('Cannot release an unaquired lock');

        if (this.deferred.length) {
            const deferred = this.deferred.shift();
            deferred!.resolve();
        } else {
            this.aquired = false;
        }
    }

    private aquired = false;
    private deferred: Deferred<void>[] = [];
}
